import React from "react";
import { SubmittedToAcumaticaTable } from "./view/SubmittedToAcumaticaTable";

interface Props {}

export const SubmittedToAcumatica: React.FC<Props> = () => {
  return (
    <>
      <SubmittedToAcumaticaTable />
    </>
  );
};
